export default "__VITE_ASSET__7e4916b1__"